'use client'

import { Common, Modal } from '@/config/NextImport'
import { usePathname } from 'next/navigation'
import { useEffect, useMemo, useRef, useState } from 'react'
import 'react-inner-image-zoom/lib/styles.min.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

const scrollToRef = (top: any, bottom: any) => {
  if (window.innerWidth < 991) {
    const scrollingElement: any = document.getElementById('xzoom-thumbs')
    scrollingElement.scrollLeft = bottom
  } else {
    const scrollingElement: any = document.getElementById('xzoom-thumbs')
    scrollingElement.scrollTop = bottom
  }
}

const ProductImages = ({ data }: any) => {
  const pathname = usePathname()
  const isDetailsPage = pathname?.includes('-sku-')
  const sku = isDetailsPage ? pathname.split('-sku-').reverse()[0] : ''
  const detail = useMemo(() => {
    return data.find((x: any) => x.sku === sku)
  }, [data, sku])

  const ImageNavigation = useRef<any>(null)
  const IsShow360Video = useRef<any>(false)
  const videoPlayButton = Common.setImagePath('assets/images/video-play-button.jpg')
  const [Is360VideoExist, setIs360VideoExist] = useState<boolean>(false)
  const [SelectedImage, setSelectedImage] = useState<any>(detail?.base_image || '')
  const [SelectedVideo, setSelectedVideo] = useState<any>('')
  const [IsShow360VideoPopup] = useState<boolean>(false)
  const TotalImages = useMemo(() => {
    return detail?.other_image.length + 1 || 0
  }, [])

  useEffect(() => {
    setSelectedImage(detail?.base_image || '')
  }, [detail])
  const TopScroll = () => {
    const scrollCurrentTop = ImageNavigation.current.scrollTop
    scrollToRef(0, scrollCurrentTop - 100)
  }

  const BottomScroll = () => {
    const scrollCurrentTop = ImageNavigation.current.scrollTop
    scrollToRef(0, scrollCurrentTop + 100)
  }

  const changeProductImage = (e: any, image: any) => {
    e.preventDefault()
    setSelectedImage(image)
    IsShow360Video.current = false
  }
  const changeProductVideo = (e: any, video: any) => {
    e.preventDefault()
    setSelectedVideo(video)
    setSelectedImage('')
  }

  if (detail === undefined || detail === null || Object.keys(detail).length < 1) return null
  return (
    <>
      <div className="product-detail-image">
        <div className="xzoom-container">
          <div className="row">
            <div className="col-lg-10 order-lg-2 xzoom-big-col">
              {SelectedImage === '' && (
                <div className="xzoom-big">
                  <video
                    autoPlay
                    loop
                    muted
                    className="xzoom-video"
                    height="579"
                    width="579"
                    src={SelectedVideo || null}
                    controls={false}
                  />
                </div>
              )}
              {SelectedImage !== '' && detail.parent_sku !== undefined && (
                <div className="xzoom-big">
                  <img
                    className={
                      IsShow360Video.current && !IsShow360VideoPopup ? 'xzoom d-none' : 'xzoom'
                    }
                    id="xzoom-default"
                    src={SelectedImage}
                    alt="Setting"
                  />
                </div>
              )}
            </div>

            <div className="col-lg-2 px-0 order-lg-1 xzoom-thumbs-col">
              {TotalImages <= 6 ? (
                ' '
              ) : (
                <div
                  id="topscroll"
                  onClick={() => TopScroll()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-up"
                  >
                    <polyline points="18 15 12 9 6 15"></polyline>
                  </svg>
                </div>
              )}
              <div
                id="xzoom-thumbs"
                className="xzoom-thumbs"
                ref={ImageNavigation}
              >
                {detail.base_image !== null &&
                  detail.base_image !== '' &&
                  detail.base_image !== 'null' && (
                    <img
                      className={
                        SelectedImage === detail.base_image
                          ? 'xzoom-gallery xzoom-gallery-shape xactive'
                          : 'xzoom-gallery xzoom-gallery-shape'
                      }
                      width="80"
                      onClick={(e) => changeProductImage(e, detail.base_image)}
                      src={detail.base_image}
                      alt="Setting"
                    />
                  )}
                {detail.modal_image !== null &&
                  detail.modal_image !== '' &&
                  detail.modal_image !== 'null' && (
                    <img
                      className={
                        SelectedImage === detail.modal_image
                          ? 'xzoom-gallery xzoom-gallery-shape xactive'
                          : 'xzoom-gallery xzoom-gallery-shape'
                      }
                      width="80"
                      onClick={(e) => changeProductImage(e, detail.modal_image)}
                      src={detail.modal_image}
                      alt="Setting"
                    />
                  )}
                {detail.dimention_image !== null &&
                  detail.dimention_image !== '' &&
                  detail.dimention_image !== 'null' && (
                    <img
                      className={
                        SelectedImage === detail.dimention_image
                          ? 'xzoom-gallery xzoom-gallery-shape xactive'
                          : 'xzoom-gallery xzoom-gallery-shape'
                      }
                      width="80"
                      onClick={(e) => changeProductImage(e, detail.dimention_image)}
                      src={detail.dimention_image}
                      alt="Setting"
                    />
                  )}
                {detail.other_image != null &&
                  Object.values(detail.other_image).map(function (key: any) {
                    if (key?.includes('video')) {
                      if (
                        key?.includes('video') &&
                        detail.video_url !== null &&
                        detail.video_url !== '' &&
                        Is360VideoExist
                      )
                        return (
                          <img
                            key={key}
                            className={
                              SelectedImage === detail.video_url
                                ? 'p-2 xzoom-video xactive'
                                : 'p-2 xzoom-gallery xzoom-gallery-shape'
                            }
                            width="80"
                            onClick={(e) => changeProductVideo(e, detail.video_url)}
                            src={key}
                            alt="Setting"
                          />
                        )
                    } else {
                      return (
                        <img
                          key={key}
                          className={
                            SelectedImage === key
                              ? 'xzoom-gallery xzoom-gallery-shape xactive other_img'
                              : 'xzoom-gallery xzoom-gallery-shape other_img'
                          }
                          width="80"
                          onClick={(e) => changeProductImage(e, key)}
                          src={key}
                          alt="Setting"
                        />
                      )
                    }
                    return true
                  })}
                {detail.video_url !== null &&
                  detail.video_url !== '' &&
                  detail.video_url !== 'null' && (
                    <img
                      className={
                        SelectedImage === detail.video_url
                          ? 'p-2 xzoom-video xactive'
                          : 'p-2 xzoom-gallery xzoom-gallery-shape'
                      }
                      width="80"
                      onClick={(e) => changeProductVideo(e, detail.video_url)}
                      src={videoPlayButton}
                      alt="Setting"
                    />
                  )}
              </div>
              {TotalImages <= 6 ? (
                ' '
              ) : (
                <div
                  id="bottomscroll"
                  onClick={() => BottomScroll()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {detail.parent_sku !== undefined && (
        <>
          <Modal
            centered
            show={IsShow360Video.current && IsShow360VideoPopup}
            // size="md"
            size="lg"
            onHide={() => (IsShow360Video.current = false)}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <h4>{detail.name}</h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => (IsShow360Video.current = false)}
              ></button>
            </Modal.Header>
            <Modal.Body>
              <video
                className={
                  !IsShow360Video.current ? 'xzoom-video d-none' : 'xzoom-video d-block d-lg-none'
                }
                onLoadedMetadata={() => setIs360VideoExist(true)}
                onAbort={() => setIs360VideoExist(false)}
                autoPlay
                height="290"
                width="290"
                src={detail.video_url}
                controls={false}
                loop
                muted
              ></video>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => (IsShow360Video.current = false)}
              >
                {' '}
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  )
}

export default ProductImages
